import { render, staticRenderFns } from "./blade-product.vue?vue&type=template&id=6a985628&scoped=true&"
import script from "./blade-product.vue?vue&type=script&lang=js&"
export * from "./blade-product.vue?vue&type=script&lang=js&"
import style0 from "./blade-product.vue?vue&type=style&index=0&id=6a985628&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a985628",
  null
  
)

export default component.exports